import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow, TableCell, Box } from '@mui/material';
import { formatDate } from '../../../../utils/formatDate';

const getColorStatus = (status) => {
  switch (status) {
    case 'Действующий':
      return 'success.main';
    case 'Использован':
      return 'text.secondary';
    case 'Архивный':
      return 'error.main';
    case 'Забронирован':
      return 'warning.main';
  }
};

export const PromocodesTableBody = ({ data }) => {
  return (
    <TableBody data-testid="TableBody">
      {data?.map(item => (
        <TableRow
          key={item.id}
          sx={{ cursor: 'pointer' }}
          data-testid="TableRow"
        >
          <TableCell>
            <Box width="90px">{item.promocode_number}</Box>
          </TableCell>

          <TableCell>
            <Box width="140px">{item.date_of_use ? formatDate(item.date_of_use, true) : '-'}</Box>
          </TableCell>

          <TableCell>
            <Box width="140px">{item.date_booking ? formatDate(item.date_booking, true) : '-'}</Box>
          </TableCell>

          <TableCell>
            <Box width="180px">{item.id}</Box>
          </TableCell>

          <TableCell>
            <Box width="180px">{item.customer_name || '-'}</Box>
          </TableCell>

          <TableCell>
            <Box width="120px">{item.customer_iin || '-'}</Box>
          </TableCell>

          <TableCell>
            <Box width="80px">{item.customer_id || '-'}</Box>
          </TableCell>

          <TableCell>
            <Box color={`${getColorStatus(item.status)}`}>{item.status}</Box>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

PromocodesTableBody.propTypes = {
  data: PropTypes.array,
  openModal: PropTypes.func,
  setCurID: PropTypes.func
};
